



































import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GColorFormInput',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    valid: { type: Boolean as PropType<boolean>, default: true },
    label: { type: String as PropType<string> },
    itemComment: { type: Array as PropType<string[]>, default: () => [] },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    value: { type: String as PropType<string> },
    error: { type: Array as PropType<string[]>, default: () => [] },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
  },
  data() {
    return {
      innerValue: this.$props.value,
    };
  },
  methods: {
    onChange(val: string) {
      this.innerValue = val;
    },
  },
  watch: {
    innerValue(val: string) {
      this.$emit('input', val);
    },
  },
});
